import ApiService from "../../common/apiService";
import { getData } from "../../common/dataHelper";
import { COURSE_TYPES, SLIDE_TYPES, STORE_TYPES } from "../types";
const state = {
    slide: null,
};

const getters = {
    [SLIDE_TYPES.GET_SLIDE](state) {
        return state.slide;
    },
};

const actions = {
    async [SLIDE_TYPES.UPDATE_MANUAL]({ rootState }) {
        const course = rootState.courses.course;
        const manualId = getData(course, "manual.id");
        const response = await ApiService.post(
            `academy/manuals/${manualId}/customerManuals`
        );
        if (getData(response, "status") == 204) {
            course.manual.is_read = true;
        }

        return response;
    },

    async [SLIDE_TYPES.UPDATE_SLIDE_PROGRESS](
        { rootState, dispatch },
        { slide, watchTime, isFinished = false }
    ) {
        const slideId = getData(slide, "id");
        const progressId = getData(slide, "progress.id");
        const params = {};
        if (isFinished) {
            params.is_finished = true;
        } else {
            params.watch_time = watchTime;
        }
        const response = await ApiService.put(
            `academy/slides/${slideId}/customerSlideProgresses/${progressId}`,
            params
        );
        if (getData(response, "status") == 200 && isFinished) {
            dispatch("setNewWatchTime", { slideId, watchTime: 0 });
            dispatch("finishSlide", { slideId });
        } else if (getData(response, "status") == 200) {
            dispatch("setNewWatchTime", { slideId, watchTime });
        }
        const newProgress = getData(response, "data.total_progress");
        if (newProgress) {
            rootState.courses.course.total_progress = newProgress;
        }

        return response;
    },
    async [SLIDE_TYPES.UPDATE_TEST_QUESTIONS](
        { rootState, dispatch },
        { slide }
    ) {
        // TODO if demoZugang return
        const slideId = getData(slide, "id");
        const testQuestions = getData(slide, "testQuestions");
        const response = await ApiService.post(
            `academy/slides/${slideId}/testResults`,
            { testQuestions }
        );
        const testResult = getData(
            response,
            "data.customerTestResults.is_finished"
        );
        if (getData(response, "status") == 200 && testResult) {
            dispatch("finishSlide", { slideId });
        }
        const newProgress = getData(response, "data.total_progress");
        if (newProgress) {
            rootState.courses.course.total_progress = newProgress;
        }

        return response;
    },
    setNewWatchTime({ rootState }, { slideId, watchTime }) {
        const course = rootState.courses.course;
        if (getData(course, "sections.length") == null) {
            return;
        }

        for (let index = 0; index < course.sections.length; index++) {
            const section = course.sections[index];
            for (
                let slideIndex = 0;
                slideIndex < section.slides.length;
                slideIndex++
            ) {
                const storeSlide = section.slides[slideIndex];
                if (storeSlide.id == slideId) {
                    storeSlide.progress.watch_time = watchTime;
                }
            }
        }
    },
    finishSlide({ dispatch, rootState }, { slideId, isPresentorMode = false }) {
        const course = rootState.courses.course;
        if (getData(course, "sections.length") == null) {
            return;
        }
        let currentSectionIndex;
        let currentSlideIndex;

        for (let index = 0; index < course.sections.length; index++) {
            const section = course.sections[index];
            for (
                let slideIndex = 0;
                slideIndex < section.slides.length;
                slideIndex++
            ) {
                const storeSlide = section.slides[slideIndex];
                if (storeSlide.id == slideId) {
                    storeSlide.progress.is_finished = true;
                    currentSectionIndex = index;
                    currentSlideIndex = slideIndex;
                }
            }
        }

        if (
            currentSlideIndex != undefined &&
            currentSectionIndex != undefined
        ) {
            dispatch("selectNextSlide", {
                sectionIndex: currentSectionIndex,
                slideIndex: currentSlideIndex,
                isPresentorMode: isPresentorMode
            });
        }
    },
    selectNextSlide({ rootState, commit }, { sectionIndex, slideIndex, isPresentorMode = false }) {
        const course = rootState.courses.course;
        if (getData(course, "sections.length") == null) {
            return;
        }
        commit(SLIDE_TYPES.SET_SLIDE, null);
        commit(
            `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SELECTED_COURSE_TYPE}`,
            null,
            { root: true }
        );
        //if section has unfinished videos
        if (
            course.sections[sectionIndex].slides.some(
                (s) => s.progress.is_finished == false
            )
            || (course.sections[sectionIndex].slides.length - 1 > slideIndex && isPresentorMode)
        ) {
            setTimeout(() => {
                commit(
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SELECTED_COURSE_TYPE}`,
                    "slide",
                    { root: true }
                );
            }, 100);

            // if next slide is unfinished
            if (course.sections[sectionIndex].slides.length > slideIndex + 1) {
                commit(
                    SLIDE_TYPES.SET_SLIDE,
                    course.sections[sectionIndex].slides[slideIndex + 1]
                );
            } else {
                for (
                    let index = 0;
                    index < course.sections[sectionIndex].slides.length;
                    index++
                ) {
                    const slide = course.sections[sectionIndex].slides[index];

                    if (slide.progress.is_finished == false) {
                        commit(SLIDE_TYPES.SET_SLIDE, slide);
                        return;
                    }
                }
            }
        }
        //set first slide of next section
        else if (course.sections.length > sectionIndex + 1) {
            if (!isPresentorMode || (isPresentorMode && course.sections[sectionIndex].slides.every(
                (s) => s.progress.is_finished == true
            ))) {
                course.sections[sectionIndex].is_finished = true;
                setTimeout(() => {
                    // This setTimeout is only used because of continuity.
                    // I dont know if it actually does something..
                    commit(
                        `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SELECTED_COURSE_TYPE}`,
                        "slide",
                        { root: true }
                    );
                    commit(
                        SLIDE_TYPES.SET_SLIDE,
                        course.sections[sectionIndex + 1].slides[0]
                    );
                }, 100);
            }
        } else {
            course.sections[sectionIndex].is_finished = true;
            commit(
                `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SELECTED_COURSE_TYPE}`,
                "feedback",
                { root: true }
            );
        }
    },
};

const mutations = {
    [SLIDE_TYPES.SET_SLIDE](state, object) {
        state.slide = object;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
